export const ensureLocaleDate = (date: string): string => {
  if (Number.isNaN(Date.parse(date))) return '';
  if (date.includes('T')) return date;

  return `${date}T00:00:00`;
};

export const getMonth = (date: string): string => {
  const isoDate = ensureLocaleDate(date);
  const dateObj = new Date(isoDate);
  const formatter = new Intl.DateTimeFormat('pt-BR', {
    month: 'long',
    timeZone: 'UTC',
  });
  const month = formatter.format(dateObj);
  return month[0].toUpperCase() + month.slice(1);
};

export const getYear = (date: string): string => {
  const isoDate = ensureLocaleDate(date);
  const formatter = new Intl.DateTimeFormat('pt-BR', { year: 'numeric' });
  return formatter.format(new Date(isoDate));
};
